import { render, staticRenderFns } from "./PageParametersEdit.vue?vue&type=template&id=68884f39"
import script from "./PageParametersEdit.vue?vue&type=script&lang=js"
export * from "./PageParametersEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68884f39')) {
      api.createRecord('68884f39', component.options)
    } else {
      api.reload('68884f39', component.options)
    }
    module.hot.accept("./PageParametersEdit.vue?vue&type=template&id=68884f39", function () {
      api.rerender('68884f39', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pageParameters/PageParametersEdit.vue"
export default component.exports